import type { GraphQLClient, RequestOptions } from 'graphql-request';
import { gql } from 'graphql-request';
export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
type GraphQLClientRequestHeaders = RequestOptions['requestHeaders'];
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Array: { input: any; output: any; }
  JsonArgument: { input: any; output: any; }
};

export type CountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type CountriesQuery = { terms?: { data?: Array<{ iso2?: string | null, title: string, phone_code?: string | null, flag?: { id: string, permalink?: string | null } | {} | null } | null> | null } | null };

export type EntryQueryVariables = Exact<{
  uri?: InputMaybe<Scalars['String']['input']>;
}>;


export type EntryQuery = { entry?: { id: string, url?: string | null, title: string, slug: string, locale: string, blueprint?: string | null, collection: { handle: string } } | { id: string, url?: string | null, title: string, slug: string, locale: string, blueprint?: string | null, collection: { handle: string } } | { id: string, url?: string | null, title: string, slug: string, locale: string, blueprint?: string | null, seo_hidden?: boolean | null, seo_title?: string | null, seo_description?: string | null, collection: { handle: string }, hero?: Array<{ heading?: string | null, text?: string | null, link?: string | null, link_text?: string | null, scroll_button_text?: string | null, type: string, image_lottie?: { id: string, alt?: string | null, permalink?: string | null, url?: string | null, extension: string, is_image?: boolean | null, width?: number | null, height?: number | null, focus_css?: string | null, size?: string | null } | {} | null } | { heading?: string | null, text?: string | null, type: string, image?: { id: string, alt?: string | null, permalink?: string | null, url?: string | null, extension: string, is_image?: boolean | null, width?: number | null, height?: number | null, focus_css?: string | null, size?: string | null } | {} | null } | { heading?: string | null, text?: string | null, link?: string | null, link_text?: string | null, type: string } | null> | null, replicator_components?: Array<{ type: string, heading?: string | null, padding?: { value?: string | null } | null, accordion_group?: Array<{ heading?: string | null, text?: string | null } | null> | null } | { type: string, heading?: string | null, padding?: { value?: string | null } | null, style?: { value?: string | null } | null, dotted_connection_lines?: { value?: string | null } | null, cards?: Array<{ text?: string | null, title?: string | null, anchor_link_text?: string | null, component_id?: string | null, link?: string | null, image?: { id: string, alt?: string | null, permalink?: string | null, url?: string | null, extension: string, is_image?: boolean | null, width?: number | null, height?: number | null, focus_css?: string | null, size?: string | null } | {} | null } | null> | null } | { type: string, heading?: string | null, padding?: { value?: string | null } | null, images_or_videos?: Array<{ video?: string | null, image?: { id: string, alt?: string | null, permalink?: string | null, url?: string | null, extension: string, is_image?: boolean | null, width?: number | null, height?: number | null, focus_css?: string | null, size?: string | null } | {} | null } | null> | null } | { type: string, heading?: string | null, text?: string | null } | { type: string, heading?: string | null, padding?: { value?: string | null } | null } | { type: string, heading?: string | null, padding?: { value?: string | null } | null, partner_logo_rows?: Array<{ partner_logos_selection?: { value?: string | null } | null, partner_logos?: Array<{ slug: string, link?: string | null, image?: { id: string, alt?: string | null, permalink?: string | null, url?: string | null, extension: string, is_image?: boolean | null, width?: number | null, height?: number | null, focus_css?: string | null, size?: string | null } | {} | null } | {} | null> | null } | null> | null } | { type: string, checkbox_text_and_link?: string | null, submit_button_text?: string | null, success_message?: string | null, error_message?: string | null, padding?: { value?: string | null } | null, registration_form?: { title: string, rules?: any | null, honeypot?: string | null, handle: string, fields?: Array<{ config?: any | null, display: string, handle: string, instructions?: string | null, type: string, width?: number | null } | null> | null } | null } | { type: string, heading?: string | null, text?: string | null, link?: string | null, link_text?: string | null, padding?: { value?: string | null } | null } | { type: string, heading?: string | null, component_id?: string | null, style?: { value?: string | null } | null, padding?: { value?: string | null } | null, teasers?: Array<{ heading?: string | null, text?: string | null, image_position?: { value?: string | null } | null, image?: { id: string, alt?: string | null, permalink?: string | null, url?: string | null, extension: string, is_image?: boolean | null, width?: number | null, height?: number | null, focus_css?: string | null, size?: string | null } | {} | null } | null> | null } | { heading?: string | null, type: string, padding?: { value?: string | null } | null, testimonial_selection?: { value?: string | null } | null, testimonials?: Array<{ id: string, title: string, testimonial?: string | null, position?: string | null, image?: { id: string, alt?: string | null, permalink?: string | null, url?: string | null, extension: string, is_image?: boolean | null, width?: number | null, height?: number | null, focus_css?: string | null, size?: string | null } | {} | null } | {} | null> | null } | { type: string, heading?: string | null, text?: string | null, link?: string | null, link_text?: string | null, component_id?: string | null, padding?: { value?: string | null } | null } | null> | null, seo_image?: { id: string, alt?: string | null, permalink?: string | null, url?: string | null, extension: string, is_image?: boolean | null, width?: number | null, height?: number | null, focus_css?: string | null, size?: string | null } | {} | null } | { id: string, url?: string | null, title: string, slug: string, locale: string, blueprint?: string | null, collection: { handle: string } } | { id: string, url?: string | null, title: string, slug: string, locale: string, blueprint?: string | null, collection: { handle: string } } | { id: string, url?: string | null, title: string, slug: string, locale: string, blueprint?: string | null, collection: { handle: string } } | { id: string, url?: string | null, title: string, slug: string, locale: string, blueprint?: string | null, collection: { handle: string } } | null };

export type LocationsQueryVariables = Exact<{ [key: string]: never; }>;


export type LocationsQuery = { countries?: { data?: Array<{ id: string, slug: string, title: string, country: { id: string, slug: string, flag?: { id: string, permalink?: string | null } | {} | null } } | {} | null> | null } | null, locations?: { data?: Array<{ id: string, title: string, latitude?: string | null, longitude?: string | null, country_code?: string | null, number_of_caterers?: number | null, parent?: { id: string } | { id: string } | { id: string } | { id: string } | { id: string } | { id: string } | { id: string } | null } | {} | null> | null } | null };

export type NavigationAndGlobalsQueryVariables = Exact<{ [key: string]: never; }>;


export type NavigationAndGlobalsQuery = { navigation?: { tree?: Array<{ page?: { id: string, entry_id?: string | null, title?: string | null, url?: string | null } | { id: string, entry_id?: string | null, title?: string | null, url?: string | null } | { id: string, entry_id?: string | null, title: string, url?: string | null } | { id: string, entry_id?: string | null, title: string, url?: string | null } | null } | null> | null } | null, footer?: { tree?: Array<{ page?: { id: string, title?: string | null, url?: string | null } | { id: string, title?: string | null, url?: string | null } | { id: string, title: string, url?: string | null } | { id: string, title: string, url?: string | null } | null } | null> | null } | null, general?: { address?: string | null, address_link?: string | null, email?: string | null, handle: string, phone?: string | null } | {} | null, teaser_registration_defaults?: { heading?: string | null, text?: string | null, link?: string | null, link_text?: string | null } | {} | null, social_media?: { social_media_links?: Array<{ heading?: string | null, link?: string | null, icon?: { id: string, alt?: string | null, permalink?: string | null, url?: string | null, extension: string, is_image?: boolean | null, width?: number | null, height?: number | null, focus_css?: string | null, size?: string | null } | {} | null } | null> | null } | {} | null, seo_defaults?: { seo_title?: string | null, seo_description?: string | null, seo_image?: { id: string, alt?: string | null, permalink?: string | null, url?: string | null, extension: string, is_image?: boolean | null, width?: number | null, height?: number | null, focus_css?: string | null, size?: string | null } | {} | null } | {} | null };

export type PartnersQueryVariables = Exact<{ [key: string]: never; }>;


export type PartnersQuery = { entries?: { data?: Array<{ slug: string, title: string, link?: string | null, image?: { id: string, alt?: string | null, permalink?: string | null, url?: string | null, extension: string, is_image?: boolean | null, width?: number | null, height?: number | null, focus_css?: string | null, size?: string | null } | {} | null } | {} | null> | null } | null };

export type TestimonialsQueryVariables = Exact<{ [key: string]: never; }>;


export type TestimonialsQuery = { entriesRandom?: { data?: Array<{ id: string, title: string, testimonial?: string | null, position?: string | null, image?: { id: string, alt?: string | null, permalink?: string | null, url?: string | null, extension: string, is_image?: boolean | null, width?: number | null, height?: number | null, focus_css?: string | null, size?: string | null } | {} | null } | {} | null> | null } | null };

type ReplicatorComponents_Set_ReplicatorComponents_AccordionGroup_Fragment = { type: string, heading?: string | null, padding?: { value?: string | null } | null, accordion_group?: Array<{ heading?: string | null, text?: string | null } | null> | null };

type ReplicatorComponents_Set_ReplicatorComponents_ColumnCards_Fragment = { type: string, heading?: string | null, padding?: { value?: string | null } | null, style?: { value?: string | null } | null, dotted_connection_lines?: { value?: string | null } | null, cards?: Array<{ text?: string | null, title?: string | null, anchor_link_text?: string | null, component_id?: string | null, link?: string | null, image?: { id: string, alt?: string | null, permalink?: string | null, url?: string | null, extension: string, is_image?: boolean | null, width?: number | null, height?: number | null, focus_css?: string | null, size?: string | null } | {} | null } | null> | null };

type ReplicatorComponents_Set_ReplicatorComponents_ImageOrVideo_Fragment = { type: string, heading?: string | null, padding?: { value?: string | null } | null, images_or_videos?: Array<{ video?: string | null, image?: { id: string, alt?: string | null, permalink?: string | null, url?: string | null, extension: string, is_image?: boolean | null, width?: number | null, height?: number | null, focus_css?: string | null, size?: string | null } | {} | null } | null> | null };

type ReplicatorComponents_Set_ReplicatorComponents_LeadText_Fragment = { type: string, heading?: string | null, text?: string | null };

type ReplicatorComponents_Set_ReplicatorComponents_LocationsMapAndList_Fragment = { type: string, heading?: string | null, padding?: { value?: string | null } | null };

type ReplicatorComponents_Set_ReplicatorComponents_PartnerLogos_Fragment = { type: string, heading?: string | null, padding?: { value?: string | null } | null, partner_logo_rows?: Array<{ partner_logos_selection?: { value?: string | null } | null, partner_logos?: Array<{ slug: string, link?: string | null, image?: { id: string, alt?: string | null, permalink?: string | null, url?: string | null, extension: string, is_image?: boolean | null, width?: number | null, height?: number | null, focus_css?: string | null, size?: string | null } | {} | null } | {} | null> | null } | null> | null };

type ReplicatorComponents_Set_ReplicatorComponents_RegistrationFrom_Fragment = { type: string, checkbox_text_and_link?: string | null, submit_button_text?: string | null, success_message?: string | null, error_message?: string | null, padding?: { value?: string | null } | null, registration_form?: { title: string, rules?: any | null, honeypot?: string | null, handle: string, fields?: Array<{ config?: any | null, display: string, handle: string, instructions?: string | null, type: string, width?: number | null } | null> | null } | null };

type ReplicatorComponents_Set_ReplicatorComponents_TeaserRegistration_Fragment = { type: string, heading?: string | null, text?: string | null, link?: string | null, link_text?: string | null, padding?: { value?: string | null } | null };

type ReplicatorComponents_Set_ReplicatorComponents_TeasersTextAndImage_Fragment = { type: string, heading?: string | null, component_id?: string | null, style?: { value?: string | null } | null, padding?: { value?: string | null } | null, teasers?: Array<{ heading?: string | null, text?: string | null, image_position?: { value?: string | null } | null, image?: { id: string, alt?: string | null, permalink?: string | null, url?: string | null, extension: string, is_image?: boolean | null, width?: number | null, height?: number | null, focus_css?: string | null, size?: string | null } | {} | null } | null> | null };

type ReplicatorComponents_Set_ReplicatorComponents_Testimonials_Fragment = { heading?: string | null, type: string, padding?: { value?: string | null } | null, testimonial_selection?: { value?: string | null } | null, testimonials?: Array<{ id: string, title: string, testimonial?: string | null, position?: string | null, image?: { id: string, alt?: string | null, permalink?: string | null, url?: string | null, extension: string, is_image?: boolean | null, width?: number | null, height?: number | null, focus_css?: string | null, size?: string | null } | {} | null } | {} | null> | null };

type ReplicatorComponents_Set_ReplicatorComponents_TextAndButton_Fragment = { type: string, heading?: string | null, text?: string | null, link?: string | null, link_text?: string | null, component_id?: string | null, padding?: { value?: string | null } | null };

export type ReplicatorComponentsFragment = ReplicatorComponents_Set_ReplicatorComponents_AccordionGroup_Fragment | ReplicatorComponents_Set_ReplicatorComponents_ColumnCards_Fragment | ReplicatorComponents_Set_ReplicatorComponents_ImageOrVideo_Fragment | ReplicatorComponents_Set_ReplicatorComponents_LeadText_Fragment | ReplicatorComponents_Set_ReplicatorComponents_LocationsMapAndList_Fragment | ReplicatorComponents_Set_ReplicatorComponents_PartnerLogos_Fragment | ReplicatorComponents_Set_ReplicatorComponents_RegistrationFrom_Fragment | ReplicatorComponents_Set_ReplicatorComponents_TeaserRegistration_Fragment | ReplicatorComponents_Set_ReplicatorComponents_TeasersTextAndImage_Fragment | ReplicatorComponents_Set_ReplicatorComponents_Testimonials_Fragment | ReplicatorComponents_Set_ReplicatorComponents_TextAndButton_Fragment;

type Asset_Asset_Assets_Fragment = { id: string, alt?: string | null, permalink?: string | null, url?: string | null, extension: string, is_image?: boolean | null, width?: number | null, height?: number | null, focus_css?: string | null, size?: string | null };

type Asset_Asset_CountryFlags_Fragment = {};

export type AssetFragment = Asset_Asset_Assets_Fragment | Asset_Asset_CountryFlags_Fragment;

type Hero_Set_Hero_HeroHome_Fragment = { heading?: string | null, text?: string | null, link?: string | null, link_text?: string | null, scroll_button_text?: string | null, type: string, image_lottie?: { id: string, alt?: string | null, permalink?: string | null, url?: string | null, extension: string, is_image?: boolean | null, width?: number | null, height?: number | null, focus_css?: string | null, size?: string | null } | {} | null };

type Hero_Set_Hero_HeroWithImage_Fragment = { heading?: string | null, text?: string | null, type: string, image?: { id: string, alt?: string | null, permalink?: string | null, url?: string | null, extension: string, is_image?: boolean | null, width?: number | null, height?: number | null, focus_css?: string | null, size?: string | null } | {} | null };

type Hero_Set_Hero_TextAndButton_Fragment = { heading?: string | null, text?: string | null, link?: string | null, link_text?: string | null, type: string };

export type HeroFragment = Hero_Set_Hero_HeroHome_Fragment | Hero_Set_Hero_HeroWithImage_Fragment | Hero_Set_Hero_TextAndButton_Fragment;

export type PartnerFragment = { slug: string, title: string, link?: string | null, image?: { id: string, alt?: string | null, permalink?: string | null, url?: string | null, extension: string, is_image?: boolean | null, width?: number | null, height?: number | null, focus_css?: string | null, size?: string | null } | {} | null };

export type TestimonialFragment = { id: string, title: string, testimonial?: string | null, position?: string | null, image?: { id: string, alt?: string | null, permalink?: string | null, url?: string | null, extension: string, is_image?: boolean | null, width?: number | null, height?: number | null, focus_css?: string | null, size?: string | null } | {} | null };

export type BlueprintPageFragment = { title: string, seo_hidden?: boolean | null, seo_title?: string | null, seo_description?: string | null, hero?: Array<{ heading?: string | null, text?: string | null, link?: string | null, link_text?: string | null, scroll_button_text?: string | null, type: string, image_lottie?: { id: string, alt?: string | null, permalink?: string | null, url?: string | null, extension: string, is_image?: boolean | null, width?: number | null, height?: number | null, focus_css?: string | null, size?: string | null } | {} | null } | { heading?: string | null, text?: string | null, type: string, image?: { id: string, alt?: string | null, permalink?: string | null, url?: string | null, extension: string, is_image?: boolean | null, width?: number | null, height?: number | null, focus_css?: string | null, size?: string | null } | {} | null } | { heading?: string | null, text?: string | null, link?: string | null, link_text?: string | null, type: string } | null> | null, replicator_components?: Array<{ type: string, heading?: string | null, padding?: { value?: string | null } | null, accordion_group?: Array<{ heading?: string | null, text?: string | null } | null> | null } | { type: string, heading?: string | null, padding?: { value?: string | null } | null, style?: { value?: string | null } | null, dotted_connection_lines?: { value?: string | null } | null, cards?: Array<{ text?: string | null, title?: string | null, anchor_link_text?: string | null, component_id?: string | null, link?: string | null, image?: { id: string, alt?: string | null, permalink?: string | null, url?: string | null, extension: string, is_image?: boolean | null, width?: number | null, height?: number | null, focus_css?: string | null, size?: string | null } | {} | null } | null> | null } | { type: string, heading?: string | null, padding?: { value?: string | null } | null, images_or_videos?: Array<{ video?: string | null, image?: { id: string, alt?: string | null, permalink?: string | null, url?: string | null, extension: string, is_image?: boolean | null, width?: number | null, height?: number | null, focus_css?: string | null, size?: string | null } | {} | null } | null> | null } | { type: string, heading?: string | null, text?: string | null } | { type: string, heading?: string | null, padding?: { value?: string | null } | null } | { type: string, heading?: string | null, padding?: { value?: string | null } | null, partner_logo_rows?: Array<{ partner_logos_selection?: { value?: string | null } | null, partner_logos?: Array<{ slug: string, link?: string | null, image?: { id: string, alt?: string | null, permalink?: string | null, url?: string | null, extension: string, is_image?: boolean | null, width?: number | null, height?: number | null, focus_css?: string | null, size?: string | null } | {} | null } | {} | null> | null } | null> | null } | { type: string, checkbox_text_and_link?: string | null, submit_button_text?: string | null, success_message?: string | null, error_message?: string | null, padding?: { value?: string | null } | null, registration_form?: { title: string, rules?: any | null, honeypot?: string | null, handle: string, fields?: Array<{ config?: any | null, display: string, handle: string, instructions?: string | null, type: string, width?: number | null } | null> | null } | null } | { type: string, heading?: string | null, text?: string | null, link?: string | null, link_text?: string | null, padding?: { value?: string | null } | null } | { type: string, heading?: string | null, component_id?: string | null, style?: { value?: string | null } | null, padding?: { value?: string | null } | null, teasers?: Array<{ heading?: string | null, text?: string | null, image_position?: { value?: string | null } | null, image?: { id: string, alt?: string | null, permalink?: string | null, url?: string | null, extension: string, is_image?: boolean | null, width?: number | null, height?: number | null, focus_css?: string | null, size?: string | null } | {} | null } | null> | null } | { heading?: string | null, type: string, padding?: { value?: string | null } | null, testimonial_selection?: { value?: string | null } | null, testimonials?: Array<{ id: string, title: string, testimonial?: string | null, position?: string | null, image?: { id: string, alt?: string | null, permalink?: string | null, url?: string | null, extension: string, is_image?: boolean | null, width?: number | null, height?: number | null, focus_css?: string | null, size?: string | null } | {} | null } | {} | null> | null } | { type: string, heading?: string | null, text?: string | null, link?: string | null, link_text?: string | null, component_id?: string | null, padding?: { value?: string | null } | null } | null> | null, seo_image?: { id: string, alt?: string | null, permalink?: string | null, url?: string | null, extension: string, is_image?: boolean | null, width?: number | null, height?: number | null, focus_css?: string | null, size?: string | null } | {} | null };

export const AssetFragmentDoc = gql`
    fragment Asset on AssetInterface {
  ... on Asset_Assets {
    id
    alt
    permalink
    url
    extension
    is_image
    width
    height
    focus_css
    extension
    size
  }
}
    `;
export const PartnerFragmentDoc = gql`
    fragment Partner on Entry_Partner_Partner {
  slug
  title
  link
  image {
    ...Asset
  }
}
    `;
export const HeroFragmentDoc = gql`
    fragment Hero on Sets_Hero {
  ... on Set_Hero_HeroHome {
    heading
    text
    link
    link_text
    scroll_button_text
    type
    image_lottie {
      ...Asset
    }
  }
  ... on Set_Hero_HeroWithImage {
    heading
    text
    type
    image {
      ...Asset
    }
  }
  ... on Set_Hero_TextAndButton {
    heading
    text
    link
    link_text
    type
  }
}
    `;
export const TestimonialFragmentDoc = gql`
    fragment Testimonial on Entry_Testimonials_Testimonial {
  id
  image {
    ...Asset
  }
  title
  testimonial
  position
}
    `;
export const ReplicatorComponentsFragmentDoc = gql`
    fragment ReplicatorComponents on Sets_ReplicatorComponents {
  ... on Set_ReplicatorComponents_TextAndButton {
    type
    heading
    text
    link
    link_text
    component_id
    padding {
      value
    }
  }
  ... on Set_ReplicatorComponents_LeadText {
    type
    heading
    text
  }
  ... on Set_ReplicatorComponents_ImageOrVideo {
    type
    padding {
      value
    }
    heading
    images_or_videos {
      video
      image {
        ...Asset
      }
    }
  }
  ... on Set_ReplicatorComponents_TeaserRegistration {
    type
    padding {
      value
    }
    heading
    text
    link
    link_text
  }
  ... on Set_ReplicatorComponents_RegistrationFrom {
    type
    padding {
      value
    }
    checkbox_text_and_link
    submit_button_text
    success_message
    error_message
    registration_form {
      title
      rules
      honeypot
      handle
      fields {
        config
        display
        handle
        instructions
        type
        width
      }
    }
  }
  ... on Set_ReplicatorComponents_TeasersTextAndImage {
    type
    heading
    component_id
    style {
      value
    }
    padding {
      value
    }
    teasers {
      heading
      image_position {
        value
      }
      text
      image {
        ...Asset
      }
    }
  }
  ... on Set_ReplicatorComponents_ColumnCards {
    type
    heading
    padding {
      value
    }
    style {
      value
    }
    dotted_connection_lines {
      value
    }
    cards {
      text
      title
      image {
        ...Asset
      }
      anchor_link_text
      component_id
      link
    }
  }
  ... on Set_ReplicatorComponents_AccordionGroup {
    type
    padding {
      value
    }
    heading
    accordion_group {
      heading
      text
    }
  }
  ... on Set_ReplicatorComponents_Testimonials {
    heading
    type
    padding {
      value
    }
    testimonial_selection {
      value
    }
    testimonials {
      ...Testimonial
    }
  }
  ... on Set_ReplicatorComponents_PartnerLogos {
    type
    heading
    padding {
      value
    }
    partner_logo_rows {
      partner_logos_selection {
        value
      }
      partner_logos {
        ... on Entry_Partner_Partner {
          slug
          link
          image {
            ...Asset
          }
        }
      }
    }
  }
  ... on Set_ReplicatorComponents_LocationsMapAndList {
    type
    padding {
      value
    }
    heading
  }
}
    `;
export const BlueprintPageFragmentDoc = gql`
    fragment BlueprintPage on Entry_Pages_Page {
  title
  hero {
    ...Hero
  }
  replicator_components {
    ...ReplicatorComponents
  }
  seo_hidden
  seo_title
  seo_description
  seo_image {
    ...Asset
  }
}
    `;
export const CountriesDocument = gql`
    query Countries {
  terms(sort: "countries") {
    data {
      ... on Term_Countries_Country {
        iso2
        title
        phone_code
        flag {
          ... on Asset_CountryFlags {
            id
            permalink
          }
        }
      }
    }
  }
}
    `;
export const EntryDocument = gql`
    query Entry($uri: String) {
  entry(uri: $uri) {
    id
    url
    title
    slug
    locale
    collection {
      handle
    }
    blueprint
    ...BlueprintPage
  }
}
    ${BlueprintPageFragmentDoc}
${HeroFragmentDoc}
${AssetFragmentDoc}
${ReplicatorComponentsFragmentDoc}
${TestimonialFragmentDoc}`;
export const LocationsDocument = gql`
    query Locations {
  countries: entries(
    collection: "locations"
    filter: {blueprint: {is: "country"}}
    sort: "order"
  ) {
    data {
      ... on Entry_Locations_Country {
        id
        slug
        title
        country {
          ... on Term_Countries_Country {
            id
            slug
            flag {
              ... on Asset_CountryFlags {
                id
                permalink
              }
            }
          }
        }
      }
    }
  }
  locations: entries(
    collection: "locations"
    filter: {blueprint: {is: "location"}}
    sort: "order"
  ) {
    data {
      ... on Entry_Locations_Location {
        id
        title
        latitude
        longitude
        country_code
        number_of_caterers
        parent {
          id
        }
      }
    }
  }
}
    `;
export const NavigationAndGlobalsDocument = gql`
    query NavigationAndGlobals {
  navigation: nav(handle: "main") {
    tree {
      page {
        id
        entry_id
        title
        url
      }
    }
  }
  footer: nav(handle: "footer") {
    tree {
      page {
        id
        title
        url
      }
    }
  }
  general: globalSet(handle: "general") {
    ... on GlobalSet_General {
      address
      address_link
      email
      handle
      phone
    }
  }
  teaser_registration_defaults: globalSet(handle: "teaser_registration_defaults") {
    ... on GlobalSet_TeaserRegistrationDefaults {
      heading
      text
      link
      link_text
    }
  }
  social_media: globalSet(handle: "social_media") {
    ... on GlobalSet_SocialMedia {
      social_media_links {
        heading
        icon {
          ...Asset
        }
        link
      }
    }
  }
  seo_defaults: globalSet(handle: "seo_defaults") {
    ... on GlobalSet_SeoDefaults {
      seo_title
      seo_description
      seo_image {
        ...Asset
      }
    }
  }
}
    ${AssetFragmentDoc}`;
export const PartnersDocument = gql`
    query Partners {
  entries(collection: "partner") {
    data {
      ...Partner
    }
  }
}
    ${PartnerFragmentDoc}
${AssetFragmentDoc}`;
export const TestimonialsDocument = gql`
    query Testimonials {
  entriesRandom(collection: "testimonials", sort: "random") {
    data {
      ...Testimonial
    }
  }
}
    ${TestimonialFragmentDoc}
${AssetFragmentDoc}`;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string, variables?: any) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType, _variables) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    Countries(variables?: CountriesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CountriesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CountriesQuery>(CountriesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'Countries', 'query', variables);
    },
    Entry(variables?: EntryQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<EntryQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<EntryQuery>(EntryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'Entry', 'query', variables);
    },
    Locations(variables?: LocationsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<LocationsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<LocationsQuery>(LocationsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'Locations', 'query', variables);
    },
    NavigationAndGlobals(variables?: NavigationAndGlobalsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<NavigationAndGlobalsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<NavigationAndGlobalsQuery>(NavigationAndGlobalsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'NavigationAndGlobals', 'query', variables);
    },
    Partners(variables?: PartnersQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PartnersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PartnersQuery>(PartnersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'Partners', 'query', variables);
    },
    Testimonials(variables?: TestimonialsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TestimonialsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TestimonialsQuery>(TestimonialsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'Testimonials', 'query', variables);
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;